import { useCallback } from "react";
import Socket from "socket";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  fadeVariants,
  staticBounceVariants
} from "shared/components/animations";

const FlusterPlayerList = ({
  users,
  roomId,
  askerPlayer,

  answererPlayer,
  isAroundTheHorn = false,
  socketCall = false,
  isJoining = false
}) => {
  const playerClickAction = (answerer) => {
    if (socketCall) {
      const data = {
        action: "select-user",
        roomId,
        playerId: isAroundTheHorn
          ? answererPlayer?.player_id
          : askerPlayer?.player_id,
        answerer
      };
      Socket.sendMessage(data);
    }
  };
  const handlePlayerClick = useCallback(
    _.debounce((answerer) => playerClickAction(answerer), 1000, {
      leading: true,
      trailing: false
    }),
    []
  );

  return (
    <>
      <motion.div
        variants={divVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className={`players-list-wrapper ${
          isJoining ? "" : "asker-list-wrapper"
        }`}
      >
        <div className={`players-list ${isJoining ? "" : "asker-list"}`}>
          {users?.map((user, index) => (
            <div
              className="players-card "
              key={index}
              onClick={() => {
                handlePlayerClick(user?.player_id);
              }}
            >
              <motion.h3 variants={fadeVariants} className="name">
                {user?.display_name}
              </motion.h3>

              <motion.div
                variants={staticBounceVariants}
                className="players-border-bg"
              >
                <img
                  alt="border"
                  src={user.profile_image}
                  className="card-border-img"
                />
              </motion.div>
            </div>
          ))}
        </div>
      </motion.div>
    </>
  );
};

export default FlusterPlayerList;
